import "components/template_promotions_single/template_promotions_single";
import "components/hero_banner/hero_banner";
import "components/promotion_info/promotion_info";